module.exports = __webpack_public_path__ + "static/media/photo258.06f49a17.jpg";